import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppStatsFoodPage } from './app-stats-food';
import {PipesModule} from "../../pipes/pipes.module";
import {ComponentsModule} from "../../components/components.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppStatsFoodPage,
  ],
  imports: [
    IonicPageModule.forChild(AppStatsFoodPage),
    PipesModule,
    DirectivesModule,
    ComponentsModule,
  ],
})
export class AppStatsFoodPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-stats-food/app-stats-food.module.ts